export const ASSIGN_PREVIEW_FORM = 'ASSIGN_PREVIEW_FORM';
export const CLEAR_PREVIEW_FORM = 'CLEAR_PREVIEW_FORM';
export const SET_FORM_PREVIEW_DROP_DOWN_LISTS = 'SET_FORM_PREVIEW_DROP_DOWN_LISTS';
export const SET_FORM_TABLE_OF_CONTENTS = 'SET_FORM_TABLE_OF_CONTENTS';
export const SET_FORM_PREVIEWER_PAGE = 'SET_FORM_PREVIEWER_PAGE';
export const SET_FORM_FILES = 'SET_FORM_FILES';
export const SET_FETCHING_FORM_FILES = 'SET_FETCHING_FORM_FILES';
export const SET_FORM_FILES_ERROR = 'SET_FORM_FILES_ERROR';
export const SET_LOADING = 'SET_LOADING';